<div class="moorl-router-link">
    <router-link
        target="_blank"
        rel="noopener"
        :to="{ name: path }"
    >
        {{ $tc('global.default.add') }}
    </router-link>
</div>